/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Container } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import BreadCrumb from '../../components/breadcrumb/BreadCrumbNavigation';
import Loading from '../../layouts/loading';
import { fetchRunningTask, fetchTaskList } from '../../services/trackerService';
import { timerCalculation, todayTimeCalculation } from '../../utils/timeCalculation';
import { QuarterGoal, TaskList, TaskSelector, WorkedToday } from './components';
import { useStyles } from './styles/timeTrackerStyles';
import TimerProvider, { TimerContext } from './context/TimerContext';

const TimeTrackerPage = () => {
  const classes = useStyles();

  const breadcrumbs = [
    {
      label: 'Home',
      path: '/',
    },
    {
      label: 'Time Tracker',
      path: '',
    },
  ];

  const {
    setTodayTime,
    setStartTime,
    loading,
    setLoading,
    setSelectedTask,
    setSelectedProject,
    isRunning,
    setRunning,
  } = useContext(TimerContext);

  const [dailyList, setDailyList] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);

  // const runningTaskChecked = useRef(false);
  // const [open, setOpen] = useState(false);

  // const fetchTaskListData = useCallback(async () => {
  //   try {
  //     setLoading(true);
  //     const response = await fetchTaskList();
  //     const taskList = response?.data?.data;
  //     if (taskList.length) {
  //       const resultArray = timerCalculation(taskList);
  //       setDailyList(resultArray);
  //     }
  //     const todayTimeSum = todayTimeCalculation(taskList);
  //     setTodayTime(todayTimeSum);
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message || 'An error occurred fetching task list');
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [setLoading, setTodayTime]);
  const fetchTaskListData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await fetchTaskList();
      const taskList = response?.data?.data;

      // set task list on daily basis
      if (taskList.length) {
        const resultArray = timerCalculation(taskList);
        setDailyList(resultArray);
      }
      const todayTimeSum = todayTimeCalculation(taskList);
      setTodayTime(todayTimeSum);

      const runningTaskResponse = await fetchRunningTask();
      const runningTask = runningTaskResponse?.data?.data;

      const runningStartTime = runningTask?.TimeTracker?.[0]?.startTime;

      // Set task and start time if running task is present
      if (runningStartTime) {
        const projectObj = {
          projectId: runningTask?.projects?.id,
          project: runningTask?.projects?.projectName,
          client: runningTask?.projects?.clients?.clientName,
        };
        const startTimeISO = new Date(runningStartTime).toISOString();
        const runningTaskDetails = { ...runningTask };
        delete runningTaskDetails.TimeTracker;

        setSelectedProject(projectObj);
        setStartTime(startTimeISO);
        setSelectedTask(runningTaskDetails);
        setRunning(true);
      } else {
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'An error occurred');
    } finally {
      setInitialLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTaskListData();
  }, [isRunning]);

  // const fetchRunningTaskData = useCallback(async () => {
  //   if (runningTaskChecked.current) return;

  //   try {
  //     const runningTaskResponse = await fetchRunningTask();
  //     const runningTask = runningTaskResponse?.data?.data;
  //     const runningStartTime = runningTask?.TimeTracker?.[0]?.startTime;
  //     if (runningStartTime) {
  //       const projectObj = {
  //         projectId: runningTask?.projects?.id,
  //         project: runningTask?.projects?.projectName,
  //         client: runningTask?.projects?.clients?.clientName,
  //       };
  //       const startTimeISO = new Date(runningStartTime).toISOString();
  //       const runningTaskDetails = { ...runningTask };
  //       delete runningTaskDetails.TimeTracker;
  //       setSelectedProject(projectObj);
  //       setStartTime(startTimeISO);
  //       setSelectedTask(runningTaskDetails);
  //       setRunning(true);
  //     } else {
  //       setRunning(false);
  //     }
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message || 'An error occurred fetching running task');
  //   } finally {
  //     runningTaskChecked.current = true;
  //   }
  // }, [setSelectedProject, setStartTime, setSelectedTask, setRunning]);

  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     await fetchTaskListData();
  //     await fetchRunningTaskData();
  //     setInitialLoading(false);
  //   };

  //   fetchInitialData();
  // }, [fetchTaskListData, fetchRunningTaskData]);

  // useEffect(() => {
  //   if (isRunning) {
  //     fetchRunningTaskData();
  //     fetchTaskListData();
  //   }
  // }, [isRunning, fetchRunningTaskData]);


  return (
    <>
      <Loading open={initialLoading || loading} />
      <Box>
        <BreadCrumb breadcrumbs={breadcrumbs} />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '84.5vh' }}>
        <Container
          sx={{
            display: 'flex',
            maxWidth: { xs: '100%', md: '550px' }, // Full width on small screens, max width on medium+
            justifyContent: "center",
            flexWrap: { xs: 'wrap', md: 'nowrap' } // Wrap content on small screens
          }}
        >
          <Box minWidth={{ xs: '100%', md: 500 }}>
            <Box sx={{ mb: 2 }}>
              <WorkedToday initialLoading={initialLoading} />
            </Box>
            <TaskSelector initialLoading={initialLoading} fetchTaskListData={fetchTaskListData} />
            {dailyList?.map((item) => (
              <TaskList key={item?.checkDate} item={item} fetchTaskListData={fetchTaskListData} />
            ))}
          </Box>
          {/* <PerformanceScoreCard breakpoints={breakpoints} score={score} /> */}
        </Container>
        <QuarterGoal />
      </Box >
    </>
  );
};

const TimeTracker = () => (
  <TimerProvider>
    <TimeTrackerPage />
  </TimerProvider>
);
export default TimeTracker;
